import React, { FormEvent, KeyboardEvent } from 'react';

import styled from 'styled-components';

import { UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import UIButton, { EUIButtonVariant } from '@aquariuxfintech/aqx-trader-react-ui/button';
import UIFormItem, { EUIFormItemVariant } from '@aquariuxfintech/aqx-trader-react-ui/form';
import { EFontSize, ESpacing, ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIInput, { EUIInputVariant } from '@aquariuxfintech/aqx-trader-react-ui/input';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { ELoginAs } from '@aqx-core/common/api/auth';
import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { IOtpLoginFormParams } from '@aqx-core/common/services/auth';

import LoginForgotPassword from '../forgot-password';

interface IOtpLoginStep2PasswordProps {
  selectedTab: ELoginAs | undefined;
  authLoginLoading: boolean | undefined;
  register: UseFormRegister<IOtpLoginFormParams>;
  password: string;
  passwordError: string | undefined;
  handleKeyDown: (event: KeyboardEvent) => void;
  isPasswordBtnDisabled: boolean;
  onUseOtp: () => void;
  onBack: () => void;
  onFormSubmit: (e?: FormEvent<HTMLFormElement>) => void;
}

const OtpLoginStep2Password: FCC<IOtpLoginStep2PasswordProps> = ({
  selectedTab,
  authLoginLoading,
  register,
  password,
  passwordError,
  handleKeyDown,
  isPasswordBtnDisabled,
  onBack,
  onFormSubmit
}) => {
  const { t } = useTranslation();

  return (
    <StyledContainer onSubmit={onFormSubmit}>
      <UIText typography={ETypography.DISPLAY_M_BOLD}>{t('Enter Password')}</UIText>

      <StyledFormInputsContainer>
        <UIFormItem variant={EUIFormItemVariant.ITEM_WITH_FIELD_LABEL} label={t('Password')} size="large">
          <UIInput
            {...register('password')}
            variant={EUIInputVariant.BORDERED_PASSWORD}
            placeholder={t('Enter your password')}
            value={password}
            error={passwordError}
            defaultShowPassword={false}
            onKeyDown={handleKeyDown}
            dataTestId={EDataTestId.LOGIN_PASSWORD}
            size="large"
          />
        </UIFormItem>
        <LoginForgotPassword selectedTab={selectedTab} />
      </StyledFormInputsContainer>

      <StyledButtonContainer>
        <UIButton
          variant={EUIButtonVariant.FILLED_THEMED}
          loading={authLoginLoading}
          dataTestId={EDataTestId.LOGIN_SUBMIT}
          size="large"
          disabled={isPasswordBtnDisabled}
          htmlType="submit"
        >
          {t('Log in')}
        </UIButton>

        <UIButton
          variant={EUIButtonVariant.TEXT_ONLY_THEMED}
          loading={authLoginLoading}
          dataTestId={EDataTestId.LOGIN_SUBMIT}
          onClick={onBack}
        >
          {t('Back to previous')}
        </UIButton>
      </StyledButtonContainer>
    </StyledContainer>
  );
};

export default OtpLoginStep2Password;

const StyledContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${ESpacing.XXXL}px;
  width: 512px;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${ESpacing.M}px;

  button:nth-child(2) {
    font-size: ${EFontSize.TEXT_L}px !important;
  }
`;

const StyledFormInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${ESpacing.REGULAR}px;
`;
